import { Component, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs';
import { AdminAppbarComponent } from '../../../../admin/layout/components/admin-appbar/admin-appbar.component';
import { BaseComponent } from '../../../../../core/shared/common/base.component';
import { DatatableComponent } from '../../../../../core/components/datatable/datatable.component';
import { environment } from '../../../../../../environments/environment';
import { checkIsDemoOrg } from '../../../../../core/models/organizations';
import DataTable from 'datatables.net-dt';

@Component({
  selector: 'app-connector-status',
  standalone: true,
  imports: [CommonModule, AdminAppbarComponent, DatatableComponent],
  templateUrl: './connector-status.component.html',
})
export class ConnectorStatusComponent extends BaseComponent {
  public route = inject(ActivatedRoute);
  public id!: number;
  private baseUrl = `/v1/analytics/administrative/downconnects`;

  public datatableUrl = signal<string>('');

  public datatableColumns = [
    {
      data: 'connector_name',
      name: 'connector_name',
      title: 'Connection Name',
      type: 'string',
      render: DataTable.render.text(),
      orderable: false,
    },
    {
      data: 'duration',
      name: 'duration',
      title: 'Duration',
      type: 'string',
      render: DataTable.render.text(),
      orderable: false,
    },
  ];

  constructor() {
    super();
    this.initEffect();
  }

  private initEffect() {
    effect(
      () => {
        this.route.queryParams.pipe(filter((params) => params['organizationId'])).subscribe((data) => {
          this.id = parseInt(data['organizationId'], 10);
          this.datatableUrl.set(this.buildUrl(this.id));
        });
      },
      { allowSignalWrites: true }
    );
  }

  private buildUrl(orgId: number): string {
    const demostr = checkIsDemoOrg() ? '/demo' : '';
    return `${environment.apiUrl}${demostr}${this.baseUrl}(${orgId})/`;
  }
}
